import { Accordion, Divider } from '@tecsinapse/cortex-react'
import React from 'react'
import { TriggerAccordion } from './trigger-accordion'
import { OptionSelect } from '@/core/utils/types'
import { SelectDealers } from './select-dealers'
import { TiposAcessos } from './tipos-acessos'
import { containsDealer } from '@/core/enums/tipo-usuario'
import { t } from '@lingui/core/macro'
import { useFormContext } from 'react-hook-form'
import { FormMultiSelect } from '../../hook-form-connectors/form-multi-select'
import { getLabel } from '@/core/utils/global-labels'

type AccordionPerfisProps = {
  possuiPerfil: boolean
  options: {
    marcasOptions: OptionSelect[]
    tiposUsuariosOptions: OptionSelect[]
    dealersOptions: OptionSelect[]
    produtosOptions: Map<string, OptionSelect[]>
  }
  tiposUsuariosSelecionados: OptionSelect[] | string[]
}

export const AccordionPerfis = ({
  possuiPerfil,
  options,
  tiposUsuariosSelecionados
}: AccordionPerfisProps) => {
  const {
    marcasOptions,
    tiposUsuariosOptions,
    dealersOptions,
    produtosOptions
  } = options

  const { setValue } = useFormContext()

  return (
    <div className={'border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por Perfil`}
          idCheckbox={'possuiPerfil'}
          value={possuiPerfil}
          fieldToClear={'possuiPerfil'}
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca space-y-deca flex flex-col flex-1'}>
            <div className={'grid grid-cols-2 gap-deca '}>
              <FormMultiSelect
                name='marcas'
                options={marcasOptions}
                label={getLabel('label.marcas')}
                className='col-span-1'
              />
              <FormMultiSelect
                name='tiposUsuarios'
                options={tiposUsuariosOptions}
                customOnChange={(elements: OptionSelect[]) => {
                  if (!elements.some(it => it.value === 'DEALER_GRUPO')) {
                    setValue('todosDealers', false)
                    setValue('dealers', [])
                    setValue('tiposAcesso', [])
                  }
                }}
                className='col-span-1'
                label={t`Tipos de Usuários`}
              />
              <SelectDealers
                name='dealers'
                render={containsDealer(
                  (tiposUsuariosSelecionados ?? []).map(tipo =>
                    typeof tipo === 'string' ? tipo : tipo.value
                  )
                )}
                options={dealersOptions}
              />
            </div>
            <TiposAcessos options={produtosOptions} />
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  )
}
